import { View, Header } from '@fairygodboss/ui';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import React from 'react';

import { UseModalState } from '../../context/ModalContext';
import { SignUpMetrics } from '../../utils/Analytics/SignUpMetrics';
import { EmitMetric } from '../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import useUser from '../../utils/useUser';

const QuickProfile = dynamic(
    () => import('../QuickProfile/QuickProfile').then((mod) => mod.QuickProfile),
    {
        loading: () => <></>,
        ssr: false,
    }
);
const Layout = ({ children }) => {
    const { user, userLoading } = useUser();
    const {
        setModalOpen,
        setModal,
        setIsPayWall,
        setLayoutType,
        setLeadInLogin,
        setAuth0,
        setLeadInPopup,
        setLoginMetrics,
    } = UseModalState();

    return (
        <>
            <Head>
                <style global jsx>
                    {`
                        .logoWide {
                            margin-top: 20px;
                        }
                        .tempHead {
                            background-color: #7d268b;
                            height: 56px;
                            position: fixed;
                            top: 0;
                            width: 100%;
                        }
                        .userInfo img {
                            max-height: 48px;
                        }
                        @media screen and (min-width: 905px) {
                            .tempHead {
                                height: 68px;
                            }
                        }
                    `}
                </style>
            </Head>
            <header>
                <div className="page-header">
                    <Header
                        user={user.isLoggedIn ? user : null}
                        useOldBreakpoints
                        onSignupClick={() => {
                            setIsPayWall(false);
                            setLayoutType(String('create'));
                            setLeadInLogin(false);
                            setLeadInPopup(false);
                            setAuth0(null);
                            setLoginMetrics(null);
                            setModal('signup');
                            setModalOpen(true);
                        }}
                        onSigninClick={() => {
                            setIsPayWall(false);
                            setLayoutType(String('login'));
                            setLeadInLogin(false);
                            setLeadInPopup(false);
                            setAuth0(null);
                            setLoginMetrics(null);
                            setModal('signin');
                            setModalOpen(true);
                        }}
                        emitMetric={EmitMetric}
                    />
                </div>
            </header>
            <span />
            {!userLoading && user.isLoggedIn && (
                <>
                    <QuickProfile userName={user.username} />
                    <SignUpMetrics user={user} />
                </>
            )}
            <View
                backgroundColor="white"
                width="100%"
                ml="auto"
                mr="auto"
                mt={{ _: '100px', md: '68px' }}
            >
                {children}
            </View>
        </>
    );
};

export default Layout;
